document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    fetch('/cart.js').then(r => r.json()).then(cart => el.textContent = cart.item_count).catch(()=>{});
  });

  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  const close = document.querySelector('[data-mobile-menu-close]');
  const backdrop = document.querySelector('[data-mobile-menu-backdrop]');
  const menuLinks = menu ? menu.querySelectorAll('a') : [];

  const setMenu = (open) => {
    if (!toggle || !menu) return;
    if (open) {
      menu.removeAttribute('hidden');
      backdrop?.removeAttribute('hidden');
      document.body.classList.add('mobile-menu-open');
    } else {
      menu.setAttribute('hidden', '');
      backdrop?.setAttribute('hidden', '');
      document.body.classList.remove('mobile-menu-open');
    }
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.classList.toggle('is-open', open);
  };

  if (toggle && menu) {
    toggle.addEventListener('click', () => setMenu(menu.hasAttribute('hidden')));
    close?.addEventListener('click', () => setMenu(false));
    backdrop?.addEventListener('click', () => setMenu(false));
    menuLinks.forEach(link => link.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hasAttribute('hidden')) setMenu(false);
    });
  }

  async function changeCartLine(line, quantity, button) {
    if (button) button.disabled = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({line, quantity})
      });
      if (!res.ok) throw new Error('Cart update failed');
      window.location.reload();
    } catch (e) {
      if (button) button.disabled = false;
      alert('לא הצלחנו לעדכן את הסל. נסו שוב.');
    }
  }

  document.querySelectorAll('[data-cart-line]').forEach(row => {
    const line = Number(row.dataset.cartLine);
    const current = () => Number(row.dataset.cartQuantity || 1);
    const minus = row.querySelector('[data-cart-minus]');
    const plus = row.querySelector('[data-cart-plus]');
    const remove = row.querySelector('[data-cart-remove]');
    if (minus) minus.addEventListener('click', () => changeCartLine(line, Math.max(0, current() - 1), minus));
    if (plus) plus.addEventListener('click', () => changeCartLine(line, current() + 1, plus));
    if (remove) remove.addEventListener('click', () => changeCartLine(line, 0, remove));
  });
});

// NUVORA V18 — lightweight cinematic motion, disabled for reduced-motion/mobile where appropriate.
document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealEls = document.querySelectorAll('[data-v18-reveal]');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, {threshold: 0.12, rootMargin: '0px 0px -7% 0px'});
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('is-visible'));
  }

  const floatStage = document.querySelector('[data-v18-float]');
  if (floatStage && !reduceMotion && window.matchMedia('(min-width: 900px)').matches) {
    let raf = null;
    floatStage.addEventListener('pointermove', (event) => {
      const rect = floatStage.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        floatStage.style.transform = `perspective(1100px) rotateX(${(-y * 3.2).toFixed(2)}deg) rotateY(${(x * 4.4).toFixed(2)}deg)`;
      });
    });
    floatStage.addEventListener('pointerleave', () => {
      floatStage.style.transform = 'perspective(1100px) rotateX(0deg) rotateY(0deg)';
    });
  }
});

// NUVORA V24 — refined interactive product stage for home + product page.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-v19-turntable]').forEach(stage => {
    const object = stage.querySelector('[data-v19-spin-object]');
    if (!object) return;
    const img = object.querySelector('[data-spin-frames]');
    const frames = img ? (img.dataset.spinFrames || '').split('|').filter(Boolean) : [];
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hint = stage.querySelector('[data-v19-spin-hint]');
    let active = false;
    let startX = 0;
    let startY = 0;
    let baseX = 0;
    let baseY = 0;
    let posX = 0;
    let posY = 0;
    let frameIndex = frames.length > 1 ? Math.floor(frames.length / 2) : 0;
    let raf = null;
    let settle = null;

    if (frames.length) {
      frames.forEach(src => { const im = new Image(); im.src = src; });
      img.src = frames[frameIndex] || img.src;
    }

    const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
    const updateFrame = () => {
      if (!frames.length) return;
      const normalized = clamp((posX + 1) / 2, 0, 1);
      const next = Math.round(normalized * (frames.length - 1));
      if (next !== frameIndex) {
        frameIndex = next;
        img.src = frames[frameIndex];
      }
    };

    const render = () => {
      const tiltY = posX * 2.8;
      const tiltX = -posY * 2.0;
      const shiftX = posX * 18;
      const shiftY = posY * 8;
      object.style.animation = 'none';
      object.style.setProperty('--v19-ry', `${tiltY.toFixed(2)}deg`);
      object.style.setProperty('--v19-rx', `${tiltX.toFixed(2)}deg`);
      object.style.setProperty('--v19-scale', active ? '1.02' : '1');
      object.style.setProperty('--v24-shift-x', `${shiftX.toFixed(2)}px`);
      object.style.setProperty('--v24-shift-y', `${shiftY.toFixed(2)}px`);
      stage.style.setProperty('--v24-stage-x', `${(-posX * 20).toFixed(2)}px`);
      stage.style.setProperty('--v24-stage-y', `${(-posY * 10).toFixed(2)}px`);
      stage.style.setProperty('--v24-glow-x', `${(posX * 28).toFixed(2)}px`);
      stage.style.setProperty('--v24-ring-tilt', `${(posX * 6).toFixed(2)}deg`);
      stage.style.setProperty('--v24-sheen-x', `${(50 + posX * 18).toFixed(2)}%`);
      updateFrame();
      raf = null;
    };
    const queue = () => { if (!raf) raf = requestAnimationFrame(render); };

    const settleBack = () => {
      clearInterval(settle);
      if (reduceMotion) {
        posX = 0; posY = 0; frameIndex = frames.length > 1 ? Math.floor(frames.length / 2) : 0;
        if (img && frames[frameIndex]) img.src = frames[frameIndex];
        queue();
        return;
      }
      settle = setInterval(() => {
        posX *= 0.78;
        posY *= 0.74;
        if (Math.abs(posX) < 0.02 && Math.abs(posY) < 0.02) {
          posX = 0; posY = 0;
          clearInterval(settle);
        }
        queue();
      }, 16);
    };

    object.addEventListener('pointerdown', event => {
      active = true;
      clearInterval(settle);
      startX = event.clientX;
      startY = event.clientY;
      baseX = posX;
      baseY = posY;
      object.classList.add('is-dragging');
      stage.classList.add('has-interacted');
      hint?.classList.add('is-hidden');
      object.setPointerCapture?.(event.pointerId);
      event.preventDefault();
    });

    object.addEventListener('pointermove', event => {
      if (!active) return;
      const rect = object.getBoundingClientRect();
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      posX = clamp(baseX + dx / Math.max(rect.width * 0.32, 1), -1, 1);
      posY = clamp(baseY + dy / Math.max(rect.height * 0.55, 1), -0.65, 0.65);
      queue();
      event.preventDefault();
    });

    const end = event => {
      if (!active) return;
      active = false;
      object.classList.remove('is-dragging');
      object.releasePointerCapture?.(event.pointerId);
      queue();
      settleBack();
    };

    object.addEventListener('pointerup', end);
    object.addEventListener('pointercancel', end);
    object.addEventListener('dblclick', () => {
      posX = 0; posY = 0;
      frameIndex = frames.length > 1 ? Math.floor(frames.length / 2) : 0;
      if (img && frames[frameIndex]) img.src = frames[frameIndex];
      stage.classList.add('has-interacted');
      queue();
    });

    object.addEventListener('keydown', event => {
      clearInterval(settle);
      if (event.key === 'ArrowLeft') posX = clamp(posX - 0.22, -1, 1);
      else if (event.key === 'ArrowRight') posX = clamp(posX + 0.22, -1, 1);
      else if (event.key === 'ArrowUp') posY = clamp(posY - 0.16, -0.65, 0.65);
      else if (event.key === 'ArrowDown') posY = clamp(posY + 0.16, -0.65, 0.65);
      else if (event.key === 'Home') { posX = 0; posY = 0; }
      else return;
      stage.classList.add('has-interacted');
      hint?.classList.add('is-hidden');
      queue();
      event.preventDefault();
    });

    queue();
  });
});

// NUVORA LIGHT v33 ambient demo
(function(){
  function initLightDemo(){
    document.querySelectorAll('[data-light-demo]').forEach(function(box){
      var btn=box.querySelector('[data-light-toggle]');
      if(!btn||btn.dataset.bound)return; btn.dataset.bound='1';
      btn.addEventListener('click',function(){
        box.classList.toggle('is-night');
        var b=btn.querySelector('b'); if(b)b.textContent=box.classList.contains('is-night')?'חזרו למצב יום':'נסו מצב לילה';
      });
    });
  }
  document.addEventListener('DOMContentLoaded',initLightDemo);
  document.addEventListener('shopify:section:load',initLightDemo);
})();

// NUVORA V34 — light-on / light-off product card interaction.
(function(){
  function initV34LightCards(){
    document.querySelectorAll('.garden-product-media-v34').forEach(function(card){
      if(card.dataset.v34Bound) return;
      card.dataset.v34Bound='1';
      card.addEventListener('touchstart', function(){ card.classList.add('is-light-off'); }, {passive:true});
      card.addEventListener('touchend', function(){ setTimeout(function(){ card.classList.remove('is-light-off'); },180); }, {passive:true});
      card.addEventListener('touchcancel', function(){ card.classList.remove('is-light-off'); }, {passive:true});
    });
  }
  document.addEventListener('DOMContentLoaded', initV34LightCards);
  document.addEventListener('shopify:section:load', initV34LightCards);
})();


// NUVORA V35 — press/hold on mobile to turn the light ON.
// Desktop uses CSS hover. On touch, the lamp lights while the finger is held.
(function(){
  function bindV35(){
    document.querySelectorAll('[data-v35-light-card]').forEach(function(card){
      if(card.dataset.v35Bound) return;
      card.dataset.v35Bound = '1';
      var isTouch = false;
      card.addEventListener('touchstart', function(){
        isTouch = true;
        card.classList.add('is-light-on');
      }, {passive:true});
      card.addEventListener('touchend', function(){
        setTimeout(function(){ card.classList.remove('is-light-on'); }, 220);
      }, {passive:true});
      card.addEventListener('touchcancel', function(){ card.classList.remove('is-light-on'); }, {passive:true});
      card.addEventListener('pointerleave', function(){
        if(!isTouch) card.classList.remove('is-light-on');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', bindV35);
  document.addEventListener('shopify:section:load', bindV35);
})();


// NUVORA V45 — stable product controls, exact bundle prices, cross-sell and gallery.
(function(){
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = (cents) => {
    try { return new Intl.NumberFormat('he-IL',{style:'currency',currency:'ILS'}).format((cents||0)/100); }
    catch(e){ return '₪'+((cents||0)/100).toFixed(2); }
  };

  function updateCartCount(){
    fetch(root+'cart.js')
      .then(r=>r.json())
      .then(c=>document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=c.item_count))
      .catch(()=>{});
  }

  function openCrosssell(){
    const modal=document.querySelector('[data-v36-crosssell]');
    if(!modal) return;
    modal.hidden=false;
    modal.removeAttribute('hidden');
    document.body.style.overflow='hidden';
  }

  function closeCrosssell(){
    const modal=document.querySelector('[data-v36-crosssell]');
    if(!modal) return;
    modal.hidden=true;
    modal.setAttribute('hidden','');
    document.body.style.overflow='';
  }

  function initProductSection(section){
    if(!section || section.dataset.v45Bound==='1') return;
    section.dataset.v45Bound='1';

    const form=section.querySelector('#V36ProductForm');
    if(!form) return;
    const json=section.querySelector('[data-v36-variants]');
    let variants=[];
    try { variants=json ? JSON.parse(json.textContent) : []; } catch(e){ variants=[]; }

    const hidden=form.querySelector('[data-v36-variant-id]');
    const qtyInput=form.querySelector('[data-v36-quantity]');
    const priceEl=section.querySelector('[data-product-price]');
    const compareEl=section.querySelector('[data-product-compare]');
    const groups=[...form.querySelectorAll('.v36-option-group')];
    let current=null;

    function selectedOptions(){
      return groups.map(g=>{
        const b=g.querySelector('.v36-option-btn.is-selected');
        return b ? b.dataset.optionValue : '';
      });
    }
    function findVariant(){
      const vals=selectedOptions();
      return variants.find(v=>v.options.every((o,i)=>o===vals[i])) || null;
    }
    function exactBundleTotal(unitPrice,q,discount){
      const discountPerUnit=Math.floor(unitPrice*discount/100);
      return (unitPrice-discountPerUnit)*q;
    }
    function refreshBundlePrices(){
      if(!current) return;
      section.querySelectorAll('[data-bundle-qty]').forEach(btn=>{
        const q=Number(btn.dataset.bundleQty||1);
        const d=Number(btn.dataset.discount||0);
        const p=btn.querySelector('[data-bundle-price]');
        if(p) p.textContent=money(exactBundleTotal(current.price,q,d));
      });
    }
    function refreshAvailability(){
      groups.forEach((g,gi)=>{
        g.querySelectorAll('.v36-option-btn').forEach(btn=>{
          const vals=selectedOptions();
          vals[gi]=btn.dataset.optionValue;
          const possible=variants.some(v=>v.available && v.options.every((o,i)=>!vals[i] || o===vals[i]));
          btn.disabled=!possible;
        });
      });
    }
    function setVariant(v){
      if(!v) return;
      current=v;
      if(hidden) hidden.value=v.id;
      if(priceEl) priceEl.textContent=money(v.price);
      section.querySelectorAll('[data-v47-sticky-price]').forEach(el=>el.textContent=money(v.price));
      const stickyPriceGlobal=document.querySelector('[data-v47-sticky-price]');
      if(stickyPriceGlobal) stickyPriceGlobal.textContent=money(v.price);
      if(compareEl){
        if(v.compare_at_price>v.price){ compareEl.hidden=false; compareEl.textContent=money(v.compare_at_price); }
        else compareEl.hidden=true;
      }
      refreshAvailability();
      refreshBundlePrices();
    }

    groups.forEach(g=>{
      g.addEventListener('click',e=>{
        const b=e.target.closest('.v36-option-btn');
        if(!b || b.disabled) return;
        e.preventDefault();
        g.querySelectorAll('.v36-option-btn').forEach(x=>x.classList.remove('is-selected'));
        b.classList.add('is-selected');
        setVariant(findVariant());
      });
    });

    section.querySelectorAll('[data-bundle-qty]').forEach(btn=>{
      btn.addEventListener('click',e=>{
        e.preventDefault();
        section.querySelectorAll('[data-bundle-qty]').forEach(x=>x.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        if(qtyInput) qtyInput.value=Number(btn.dataset.bundleQty||1);
      });
    });

    // NUVORA V48 — on normal product visits, prefer the cheapest available 4-unit pack.
    // If Meta/Shopify sends an explicit ?variant=... URL, keep that exact variant.
    function applyVariantButtons(v){
      if(!v) return;
      groups.forEach((g,i)=>{
        g.querySelectorAll('.v36-option-btn').forEach(btn=>{
          btn.classList.toggle('is-selected', btn.dataset.optionValue===v.options[i]);
        });
      });
    }
    function isFourPack(v){
      if(!v) return false;
      const text=[v.title,...(v.options||[])].join(' ').toLowerCase();
      return /(^|\D)4\s*(pcs?|pack|pieces?|units?|יח(?:ידה|ידות))(?=\D|$)/i.test(text)
        || /(^|\D)4(?=\D|$)/.test(text) && /(pcs?|pack|pieces?|units?|יח(?:ידה|ידות))/i.test(text);
    }
    const urlVariant=new URLSearchParams(window.location.search).get('variant');
    let initial=null;
    if(urlVariant){
      initial=variants.find(v=>String(v.id)===String(urlVariant) && v.available)
        || variants.find(v=>String(v.id)===String(hidden&&hidden.value));
    }else{
      const fourPacks=variants.filter(v=>v.available && isFourPack(v)).sort((a,b)=>a.price-b.price);
      initial=fourPacks[0]
        || variants.filter(v=>v.available).sort((a,b)=>a.price-b.price)[0]
        || findVariant()
        || variants[0];
    }
    if(initial){
      applyVariantButtons(initial);
      setVariant(initial);
    }

    let submitting=false;
    async function addToCart(button){
      if(submitting) return;
      submitting=true;
      const old=button ? button.textContent : '';
      if(button){ button.disabled=true; button.textContent='מוסיף לסל…'; }
      try{
        const fd=new FormData(form);
        const res=await fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd});
        if(!res.ok) throw new Error('add failed');
        updateCartCount();
        openCrosssell();
        if(button){ button.textContent='נוסף לסל ✓'; setTimeout(()=>{button.textContent=old;button.disabled=false;},1200); }
      }catch(err){
        if(button){ button.textContent='נסו שוב'; button.disabled=false; }
      }finally{
        setTimeout(()=>{submitting=false;},250);
      }
    }

    const addBtn=form.querySelector('[data-v36-add]');
    if(addBtn){
      addBtn.addEventListener('click',e=>{
        e.preventDefault();
        addToCart(addBtn);
      });
    }
    const stickyAdd=document.querySelector('[data-v47-sticky-add]');
    if(stickyAdd && !stickyAdd.dataset.v47Bound){
      stickyAdd.dataset.v47Bound='1';
      stickyAdd.addEventListener('click',e=>{
        e.preventDefault();
        addToCart(stickyAdd);
      });
    }
    form.addEventListener('submit',e=>{
      e.preventDefault();
      if(addBtn) addToCart(addBtn);
    });
  }

  function bindGallery(){
    document.querySelectorAll('[data-gallery-src]').forEach(btn=>{
      if(btn.dataset.v45Bound==='1') return;
      btn.dataset.v45Bound='1';
      btn.addEventListener('click',e=>{
        e.preventDefault();
        const main=document.getElementById('V36MainProductImage');
        const trigger=document.querySelector('.v36-zoom-trigger');
        if(main){
          main.src=btn.dataset.gallerySrc;
          if(trigger) trigger.dataset.zoomSrc=btn.dataset.zoomSrc || btn.dataset.gallerySrc;
        }
      });
    });
    document.querySelectorAll('.v36-zoom-trigger').forEach(btn=>{
      if(btn.dataset.v45Zoom==='1') return;
      btn.dataset.v45Zoom='1';
      btn.addEventListener('click',e=>{
        e.preventDefault();
        const z=document.querySelector('[data-v36-zoom]');
        if(!z) return;
        const img=z.querySelector('[data-v36-zoom-image]');
        if(img) img.src=btn.dataset.zoomSrc || document.getElementById('V36MainProductImage')?.src || '';
        z.hidden=false; z.removeAttribute('hidden'); document.body.style.overflow='hidden';
      });
    });
    document.querySelectorAll('[data-v36-zoom-close]').forEach(x=>{
      if(x.dataset.v45Bound==='1') return;
      x.dataset.v45Bound='1';
      x.addEventListener('click',()=>{
        const z=document.querySelector('[data-v36-zoom]');
        if(z){ z.hidden=true; z.setAttribute('hidden',''); document.body.style.overflow=''; }
      });
    });
  }

  function bindCrosssell(){
    document.querySelectorAll('[data-v36-crosssell-close]').forEach(x=>{
      if(x.dataset.v45Bound==='1') return;
      x.dataset.v45Bound='1';
      x.addEventListener('click',e=>{ e.preventDefault(); closeCrosssell(); });
    });
    document.querySelectorAll('[data-v36-quick-add]').forEach(btn=>{
      if(btn.dataset.v45Bound==='1') return;
      btn.dataset.v45Bound='1';
      btn.addEventListener('click',async e=>{
        e.preventDefault();
        const old=btn.textContent; btn.disabled=true; btn.textContent='מוסיף…';
        try{
          const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(btn.dataset.v36QuickAdd),quantity:1}]})});
          if(!r.ok) throw new Error();
          updateCartCount(); btn.textContent='נוסף ✓';
        }catch(e2){ btn.textContent='נסו שוב'; }
        setTimeout(()=>{btn.textContent=old;btn.disabled=false;},1200);
      });
    });
  }

  function init(){
    document.querySelectorAll('[data-v36-product]').forEach(initProductSection);
    bindGallery();
    bindCrosssell();
  }
  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',init);
})();

// NUVORA V37 — true OFF/ON image switching.
// Desktop: hover. Touch devices: light stays ON only while finger is held.
(function(){
  function bindV37LightCards(){
    document.querySelectorAll('[data-v37-light-card]').forEach(function(card){
      if(card.dataset.v37Bound) return;
      card.dataset.v37Bound='1';
      card.addEventListener('touchstart',function(){card.classList.add('is-light-on');},{passive:true});
      card.addEventListener('touchend',function(){setTimeout(function(){card.classList.remove('is-light-on');},160);},{passive:true});
      card.addEventListener('touchcancel',function(){card.classList.remove('is-light-on');},{passive:true});
    });
  }
  document.addEventListener('DOMContentLoaded',bindV37LightCards);
  document.addEventListener('shopify:section:load',bindV37LightCards);
})();


// NUVORA V41 — robust mobile menu binding for Shopify preview/theme re-renders.
(function(){
  function bindMobileMenuV41(){
    const toggle=document.querySelector('[data-mobile-menu-toggle]');
    const menu=document.querySelector('[data-mobile-menu]');
    const close=document.querySelector('[data-mobile-menu-close]');
    if(!toggle||!menu) return;
    if(toggle.dataset.v41MenuBound==='1') return;
    toggle.dataset.v41MenuBound='1';

    function setMenu(open){
      if(open){
        menu.removeAttribute('hidden');
        document.body.classList.add('mobile-menu-open');
        toggle.setAttribute('aria-expanded','true');
        toggle.classList.add('is-open');
      }else{
        menu.setAttribute('hidden','');
        document.body.classList.remove('mobile-menu-open');
        toggle.setAttribute('aria-expanded','false');
        toggle.classList.remove('is-open');
      }
    }

    toggle.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      setMenu(menu.hasAttribute('hidden'));
    },{passive:false});

    close?.addEventListener('click',function(e){
      e.preventDefault();
      setMenu(false);
    },{passive:false});

    menu.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click',function(){setMenu(false);});
    });

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&!menu.hasAttribute('hidden')) setMenu(false);
    });
  }

  function scheduleBind(){
    bindMobileMenuV41();
    setTimeout(bindMobileMenuV41,100);
    setTimeout(bindMobileMenuV41,450);
    setTimeout(bindMobileMenuV41,1200);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scheduleBind,{once:true});
  else scheduleBind();
  document.addEventListener('shopify:section:load',scheduleBind);
  document.addEventListener('shopify:section:reorder',scheduleBind);
  window.addEventListener('pageshow',scheduleBind);

  // Shopify preview can replace the header DOM without a full page load.
  if('MutationObserver' in window){
    let t;
    const observer=new MutationObserver(function(){
      clearTimeout(t);
      t=setTimeout(bindMobileMenuV41,80);
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }
})();


// NUVORA V43 — optional close enhancement for the native details drawer.
// Opening remains native HTML and does not depend on JavaScript.
(function(){
  function bindV43MenuClose(){
    document.querySelectorAll('[data-v43-menu-close]').forEach(function(btn){
      if(btn.dataset.v43Bound) return;
      btn.dataset.v43Bound='1';
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var details=btn.closest('details');
        if(details) details.removeAttribute('open');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', bindV43MenuClose);
  document.addEventListener('shopify:section:load', bindV43MenuClose);
  window.addEventListener('pageshow', bindV43MenuClose);
})();

// NUVORA V46 — resilient product gallery, fullscreen viewer, arrows + mobile swipe.
(function(){
  let zoomItems=[];
  let zoomIndex=0;
  let touchStartX=null;

  function collectZoomItems(){
    const thumbs=[...document.querySelectorAll('[data-gallery-src]')];
    zoomItems=thumbs.map(b=>b.dataset.zoomSrc||b.dataset.gallerySrc).filter(Boolean);
    if(!zoomItems.length){
      const main=document.getElementById('V36MainProductImage');
      if(main&&main.src) zoomItems=[main.src];
    }
    return zoomItems;
  }

  function renderZoom(index){
    const modal=document.querySelector('[data-v36-zoom]');
    if(!modal) return;
    const items=collectZoomItems();
    if(!items.length) return;
    zoomIndex=(index+items.length)%items.length;
    const img=modal.querySelector('[data-v36-zoom-image]');
    const count=modal.querySelector('[data-v46-zoom-count]');
    if(img) img.src=items[zoomIndex];
    if(count) count.textContent=(zoomIndex+1)+' / '+items.length;
    modal.querySelectorAll('[data-v46-zoom-prev],[data-v46-zoom-next]').forEach(btn=>btn.hidden=items.length<2);
  }

  function openZoom(src){
    const modal=document.querySelector('[data-v36-zoom]');
    if(!modal) return;
    const items=collectZoomItems();
    let idx=items.findIndex(x=>x===src);
    if(idx<0){
      // Asset/CDN query parameters can differ; compare the path when possible.
      try{
        const target=new URL(src,location.href).pathname;
        idx=items.findIndex(x=>new URL(x,location.href).pathname===target);
      }catch(e){}
    }
    zoomIndex=idx>=0?idx:0;
    renderZoom(zoomIndex);
    modal.hidden=false;
    modal.removeAttribute('hidden');
    document.body.style.overflow='hidden';
  }

  function closeZoom(){
    const modal=document.querySelector('[data-v36-zoom]');
    if(!modal) return;
    modal.hidden=true;
    modal.setAttribute('hidden','');
    document.body.style.overflow='';
  }

  // Capture-phase delegation survives Shopify section re-renders and works on touch + desktop.
  document.addEventListener('click',function(e){
    const thumb=e.target.closest('[data-gallery-src]');
    if(thumb){
      e.preventDefault();
      const main=document.getElementById('V36MainProductImage');
      const trigger=document.querySelector('.v36-zoom-trigger');
      if(main){
        main.src=thumb.dataset.gallerySrc;
        main.removeAttribute('srcset');
        if(trigger) trigger.dataset.zoomSrc=thumb.dataset.zoomSrc||thumb.dataset.gallerySrc;
      }
      document.querySelectorAll('[data-gallery-src]').forEach(x=>x.classList.toggle('is-selected',x===thumb));
      return;
    }

    const trigger=e.target.closest('.v36-zoom-trigger');
    if(trigger){
      e.preventDefault();
      const src=trigger.dataset.zoomSrc||document.getElementById('V36MainProductImage')?.src||'';
      openZoom(src);
      return;
    }

    if(e.target.closest('[data-v36-zoom-close]')){
      e.preventDefault(); closeZoom(); return;
    }
    if(e.target.closest('[data-v46-zoom-prev]')){
      e.preventDefault(); renderZoom(zoomIndex-1); return;
    }
    if(e.target.closest('[data-v46-zoom-next]')){
      e.preventDefault(); renderZoom(zoomIndex+1); return;
    }
  },true);

  document.addEventListener('keydown',function(e){
    const modal=document.querySelector('[data-v36-zoom]');
    if(!modal||modal.hasAttribute('hidden')) return;
    if(e.key==='Escape') closeZoom();
    if(e.key==='ArrowLeft') renderZoom(zoomIndex+1);
    if(e.key==='ArrowRight') renderZoom(zoomIndex-1);
  });

  document.addEventListener('touchstart',function(e){
    const stage=e.target.closest('[data-v46-zoom-stage]');
    if(!stage||!e.touches||!e.touches[0]) return;
    touchStartX=e.touches[0].clientX;
  },{passive:true});
  document.addEventListener('touchend',function(e){
    if(touchStartX===null) return;
    const stage=e.target.closest('[data-v46-zoom-stage]');
    if(!stage){touchStartX=null;return;}
    const end=e.changedTouches&&e.changedTouches[0]?e.changedTouches[0].clientX:touchStartX;
    const dx=end-touchStartX;
    touchStartX=null;
    if(Math.abs(dx)<45) return;
    if(dx<0) renderZoom(zoomIndex+1); else renderZoom(zoomIndex-1);
  },{passive:true});
})();
